import { render, staticRenderFns } from "./SelfSelection.vue?vue&type=template&id=393770cc&"
import script from "./SelfSelection.vue?vue&type=script&lang=js&"
export * from "./SelfSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports